import Vue from "vue";
import store from "@/store";
import i18n from "@/i18n";

const errorHandler = (error) => {
  let defmsg = i18n.t("globals.defError");
  let message = "";

  if (error.networkError) {
    return defmsg;
  }

  if (_.isArray(error.graphQLErrors)) {
    if (error.graphQLErrors[0].extensions.category == "validation") {
      let fields = _.values(error.graphQLErrors[0].extensions.validation);
      message = _.join(fields, "\n");
    } else {
      var parsed;
      message = error.graphQLErrors[0].message;

      try {
        parsed = JSON.parse(message);
      } catch (err) {
        // Ignore parsing errors
      }
    }

    if (_.isObject(parsed)) {
      message = parsed[_.keys(parsed)[0]][0];
    }

    if (message == "Internal server error") {
      message = defmsg;
    }
    if (message === "User not found or not active") {
      message = i18n.t("login.userNotFound");
    }
  }
  store.commit("app/setNotifier", message);
};

const responseHandler = (data) => {
  let message = "Unknown Error";
  if (typeof data == "string") {
    message = data;
  } else {
    message = data.data[_.keys(data.data)[0]].message;
  }
  store.commit("app/setNotifier", message);
};

const colorPnL = (value, halving = 0) => {
  value = parseFloat(value);
  if (value == 0) return "text-neutral";
  if (value > 0) return "text-positive";
  if (value < 0 && halving == 0) return "text-negative";
  if (value < 0 && halving >= Math.abs(value / 2)) {
    return "text-neutral";
  } else {
    return "text-negative";
  }
};

const colorStatus = (value) => {
  if (value == "paid") return "text-positive";
  if (value == "unpaid") return "text-negative";
  if (value == "cancel") return "text-neutral";
  if (value == "canceled") return "text-neutral";
  if (value == "disabled") return "text-neutral";

  if (value == "active") return "text-positive";
  if (value == "enabled") return "text-positive";
  if (value == "connected") return "text-positive";
  if (value == "success") return "text-positive";
  if (value == "disconnected") return "text-negative";
  if (value == "failed") return "text-negative";
  if (value == "error") return "text-negative";
  if (value == "paused") return "text-negative";
  if (value == "completed") return "text-positive";

  if (value == "low") return "text-positive";
  if (value == "medium") return "text-neutral";
  if (value == "high") return "text-negative";

  if (value == "active") return "text-positive";
  if (value === "canceled") return "text-negative";
  if (value == "invited") return "text-neutral";
};

function onlyForNumber($event) {
  const code = $event.which ? $event.which : $event.keyCode;

  if (code < 48 || code > 57) return false;
  return true;
}

const onlyForCurrency = ($event, currency) => {
  let keyCode = $event.keyCode ? $event.keyCode : $event.which;
  currency = String(currency || "")

  // Allow only digits and dot
  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
    $event.preventDefault();
    return;
  }

  // Block multiple dots
  if (keyCode === 46 && currency.indexOf(".") > -1) {
    $event.preventDefault();
    return;
  }

  // Block multiple zeros at the beginning (e.g., "00", "000")
  // But allow "0.0", "0.00", "0.02", etc.
  if (keyCode === 48) {
    // If current value is empty or equals "0", block entering another zero
    if (currency === "" || currency === "0") {
      $event.preventDefault();
      return;
    }
  }
};

// Special function for price input - more flexible
const onlyForPrice = ($event, price) => {
  let keyCode = $event.keyCode ? $event.keyCode : $event.which;
  price = String(price || "")

  // Allow only digits and dot
  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
    $event.preventDefault();
    return;
  }

  // Block multiple dots
  if (keyCode === 46 && price.indexOf(".") > -1) {
    $event.preventDefault();
    return;
  }

  // For prices, allow all digits after dot, including zeros
  // Block only multiple zeros at the beginning without dot
  if (keyCode === 48 && price === "0") {
    $event.preventDefault();
    return;
  }
};

const parseNumber = (str, $method = "float") => {
  if (typeof str !== "string") return;
  str = str.replace(/\s+/g, "");
  return $method == "float" ? parseFloat(str) : parseInt(str);
};

const routeNotAllowed = (wl, module) => {
  if (wl && wl.modules > 0) {
    module = wl.modules.find(item => item.public_config.menu.path == module)
  }
  if (!module) {
    return false
  }
  return true
};

Vue.mixin({
  methods: {
    errorHandler,
    responseHandler,
    colorPnL,
    colorStatus,
    onlyForCurrency,
    onlyForPrice,
    onlyForNumber,
    parseNumber,
    routeNotAllowed
  },
});
